import { render, staticRenderFns } from "./DescargarReparto.vue?vue&type=template&id=612bd525&"
import script from "./DescargarReparto.vue?vue&type=script&lang=js&"
export * from "./DescargarReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports